export default "__VITE_ASSET__bc86846d__"